<fury-page-layout>
    <fury-page-layout-content @fadeInUp>
        <fury-container *ngIf="form">
            <form [formGroup]="form">
                <div fxLayout="row" fxLayoutGap="36px">
                    <div fxFlex="100" fxFlex.gt-sm="80" fxLayout="column">
                        <ng-container *ngIf="!formSubmitting && !formSubmitErrorSubmitted">
                            <ng-container *ngIf="form.controls.report_type_id.value === 1">
                                <h1>Overzicht van uw melding</h1>
                                <p>
                                    Hieronder vindt u een overzicht van uw melding zodat u deze nogmaals kan controleren.
                                </p>
                                <div class="grey-block">
                                    <div class="grey-block-header">
                                        <h2>Details van uw melding</h2>
                                        <button mat-flat-button (click)="editForm('melding')">
                                            <mat-icon>create</mat-icon>
                                            Deze gegevens wijzigen
                                        </button>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Melding type:</div>
                                        <div fxFlex.gt-sm="67">Klacht</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Plaats:</div>
                                        <div fxFlex.gt-sm="67">{{ getTextValue('mainCategoriesSurroundings', form.controls.surrounding_id.value) }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Type overlast:</div>
                                        <div fxFlex.gt-sm="67">{{ getTextValue('headCategories', form.controls.head_category_id.value) }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Soort overlast:</div>
                                        <div fxFlex.gt-sm="67">{{ getTextValue('mainCategories', form.controls.main_category_id.value) }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row" *ngIf="form.controls.sub_category_id.value">
                                        <div fxFlex.gt-sm="33">Specifieke overlast:</div>
                                        <div fxFlex.gt-sm="67">{{ getTextValue('subCategories', form.controls.sub_category_id.value) }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Toelichting overlast:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.description.value }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Datum en tijd waarneming:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.noticed_at.value | date:'dd-MM-YY HH:mm' }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Bekend met veroorzaker:</div>
                                        <div fxFlex.gt-sm="67">{{ getTextValue('yesNo', form.controls.suspect_known.value) }}</div>
                                    </div>
                                    <ng-container *ngIf="form.controls.suspect_type.value !== 'unknown'">
                                        <div fxLayout="column" fxLayout.gt-sm="row">
                                            <div fxFlex.gt-sm="33">Type veroorzaker:</div>
                                            <div fxFlex.gt-sm="67">{{ form.controls.suspect_type.value }}</div>
                                        </div>
                                        <div fxLayout="column" fxLayout.gt-sm="row">
                                            <div fxFlex.gt-sm="33">Vermoedelijke veroorzaker:</div>
                                            <div fxFlex.gt-sm="67">{{ form.controls.suspect_name.value }}</div>
                                        </div>
                                    </ng-container>
                                    <div fxLayout="column" fxLayout.gt-sm="column">
                                        <div>Foto's of bestanden van uw overlast:</div>
                                        <div formArrayName="attachments">
                                            <div *ngFor="let file of webformService.normalForm.controls.attachments.controls; let i = index">
                                                <fury-removable-attachment [index]="i" [attachment]="file.value"
                                                                           [removable]="false"></fury-removable-attachment>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grey-block">
                                    <div class="grey-block-header">
                                        <h2>Waar ervaart u de overlast?</h2>
                                        <button mat-flat-button (click)="editForm('melding-locatie')">
                                            <mat-icon>create</mat-icon>
                                            Deze gegevens wijzigen
                                        </button>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Locatie:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.report_location.value }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Toelichting locatie overlast:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.report_location_description.value }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Gelijk aan woonadres:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.same_as_reporter_address.value ? 'Ja' : 'Nee' }}</div>
                                    </div>
                                </div>
                                <div class="grey-block">
                                    <div class="grey-block-header">
                                        <h2>Contact gegevens</h2>
                                        <button mat-flat-button (click)="editForm('melder')">
                                            <mat-icon>create</mat-icon>
                                            Deze gegevens wijzigen
                                        </button>
                                    </div>
                                    <ng-container *ngIf="form.controls.reporter_anonymous.value === false">
                                        <div fxLayout="column" fxLayout.gt-sm="row">
                                            <div fxFlex.gt-sm="33">Persoon of een bedrijf:</div>
                                            <div fxFlex.gt-sm="67">{{ getTextValue('reporterTypes', form.controls.reporter_type_id.value) }}</div>
                                        </div>
                                        <div fxLayout="column" fxLayout.gt-sm="row" *ngIf="form.controls.reporter_type_id === 2">
                                            <div fxFlex.gt-sm="33">Uw bedrijfsnaam:</div>
                                            <div fxFlex.gt-sm="67">{{ form.controls.reporter_organisation.value }}</div>
                                        </div>
                                        <div fxLayout="column" fxLayout.gt-sm="row">
                                            <div fxFlex.gt-sm="33">Aanhef:</div>
                                            <div fxFlex.gt-sm="67">{{ form.controls.reporter_prefix.value }}</div>
                                        </div>
                                        <div fxLayout="column" fxLayout.gt-sm="row">
                                            <div fxFlex.gt-sm="33">Voorletters:</div>
                                            <div fxFlex.gt-sm="67">{{ form.controls.reporter_initials.value }}</div>
                                        </div>
                                        <div fxLayout="column" fxLayout.gt-sm="row">
                                            <div fxFlex.gt-sm="33">Tussenvoegsel:</div>
                                            <div fxFlex.gt-sm="67">{{ form.controls.reporter_middlename.value }}</div>
                                        </div>
                                        <div fxLayout="column" fxLayout.gt-sm="row">
                                            <div fxFlex.gt-sm="33">Achternaam:</div>
                                            <div fxFlex.gt-sm="67">{{ form.controls.reporter_lastname.value }}</div>
                                        </div>
                                        <div fxLayout="column" fxLayout.gt-sm="row">
                                            <div fxFlex.gt-sm="33">Woonadres:</div>
                                            <div fxFlex.gt-sm="67">{{ form.controls.reporter_location.value }}</div>
                                        </div>
                                        <div fxLayout="column" fxLayout.gt-sm="row">
                                            <div fxFlex.gt-sm="33">E-mail:</div>
                                            <div fxFlex.gt-sm="67">{{ form.controls.reporter_email.value }}</div>
                                        </div>
                                        <div fxLayout="column" fxLayout.gt-sm="row">
                                            <div fxFlex.gt-sm="33">Telefoonnummer:</div>
                                            <div fxFlex.gt-sm="67">{{ form.controls.reporter_phone.value }}</div>
                                        </div>
                                        <div fxLayout="column" fxLayout.gt-sm="row">
                                            <div fxFlex.gt-sm="33">Notificatie ontvangen:</div>
                                            <div fxFlex.gt-sm="67">{{ form.controls.reporter_notify.value ? 'Ja' : 'Nee' }}</div>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="form.controls.reporter_anonymous.value === true">
                                        Verstuur overlast anoniem
                                    </ng-container>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="form.controls.report_type_id.value === 2">
                                <h1>Overzicht van uw melding</h1>
                                <p>
                                    Hieronder vindt u een overzicht van uw melding zodat u deze nogmaals kan controleren.
                                </p>
                                <div class="grey-block">
                                    <div class="grey-block-header">
                                        <h2>Details van uw melding</h2>
                                        <button mat-flat-button (click)="editForm('melding')">
                                            <mat-icon>create</mat-icon>
                                            Deze gegevens wijzigen
                                        </button>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Melding type:</div>
                                        <div fxFlex.gt-sm="67">Bedrijfsmelding</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Toelichting overlast:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.description.value }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Wanneer vinden de voorgenomen werkzaamheden plaats:</div>
                                        <div fxFlex.gt-sm="67">
                                            {{ form.controls.noticed_at.value | date:'dd-MM-YY HH:mm' }}
                                            <ng-container *ngIf="form.controls.end_at.value">
                                                tot einde
                                                {{ form.controls.end_at.value | date:'dd-MM-YY HH:mm' }}
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                                <div class="grey-block">
                                    <div class="grey-block-header">
                                        <h2>Locatie van de voorgenomen activiteiten</h2>
                                        <button mat-flat-button (click)="editForm('melding-locatie')">
                                            <mat-icon>create</mat-icon>
                                            Deze gegevens wijzigen
                                        </button>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Locatie:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.report_location.value }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Toelichting locatie overlast</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.report_location_description.value }}</div>
                                    </div>
                                </div>
                                <div class="grey-block">
                                    <div class="grey-block-header">
                                        <h2>Uw bedrijfsgegevens</h2>
                                        <button mat-flat-button (click)="editForm('bedrijf')">
                                            <mat-icon>create</mat-icon>
                                            Deze gegevens wijzigen
                                        </button>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Uw bedrijfsnaam:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.suspect_name.value }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Bedrijfsadres:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.suspect_location.value }}</div>
                                    </div>
                                </div>
                                <div class="grey-block">
                                    <div class="grey-block-header">
                                        <h2>Contactpersoon</h2>
                                        <button mat-flat-button (click)="editForm('melder')">
                                            <mat-icon>create</mat-icon>
                                            Deze gegevens wijzigen
                                        </button>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Aanhef:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.reporter_prefix.value }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Voorletters:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.reporter_initials.value }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Tussenvoegsel:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.reporter_middlename.value }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Achternaam:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.reporter_lastname.value }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">E-mail:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.reporter_email.value }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Telefoonnummer:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.reporter_phone.value }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayout.gt-sm="row">
                                        <div fxFlex.gt-sm="33">Notificatie ontvangen:</div>
                                        <div fxFlex.gt-sm="67">{{ form.controls.reporter_notify.value ? 'Ja' : 'Nee' }}</div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                        <div *ngIf="formSubmitting" class="form-loading-overlay">
                            Uw melding wordt op dit moment verwerkt, een moment geduld aub ...
                            <div class="progress">
                                <div class="progress-bar" [style.width]="uploadProgress + '%'"></div>
                            </div>
                        </div>
                        <div *ngIf="formSubmitError" class="form-loading-error">
                            <p>Er is een fout opgetreden bij het maken van een melding. Verstuur ons de foutgegevens en wij gaan ermee aan de slag.</p>
                            <br>
                            <p>De gegevens van uw rapportage hebben wij ontvangen en zullen nogmaals de melding aanmaken met de door u aangeleverde gegevens.
                                Dit wordt zo snel mogelijk verwerkt.</p>
                        </div>
                        <div *ngIf="formSubmitErrorSubmitted" class="form-loading-info">
                            <p>Wij hebben uw gegevens in goede orde ontvangen en zullen uw melding zo spoedig opnieuw indienen.</p>
                        </div>
                        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="16px" fxLayoutGap.gt-sm="32px"
                             *ngIf="!formSubmitting && !formSubmitErrorSubmitted">
                            <button color="secondary" fxFlex="100" fxFlex.gt-sm="50" mat-button routerLink="/klacht-overlast" type="button">
                                Annuleer melding
                                <mat-icon>cancel</mat-icon>
                            </button>
                            <button *ngIf="!formSubmitError" (click)="submit()" color="primary" fxFlex="100" fxFlex.gt-sm="50" mat-button>
                                Verstuur melding
                                <mat-icon>play_circle_outline</mat-icon>
                            </button>
                            <button *ngIf="formSubmitError" (click)="failedReport()" color="primary" fxFlex="100" fxFlex.gt-sm="50" mat-button>
                                Verstuur melding
                                <mat-icon>play_circle_outline</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div class="steps-container" fxFlex.gt-sm="250px" fxHide fxLayout="row" fxLayoutAlign="flex-end" fxShow.gt-sm>
                        <ul class="steps">
                            <ng-container *ngIf="form.controls.report_type_id.value === 1">
                                <li class="step">Uw melding</li>
                                <li class="step">Locatie van uw melding</li>
                                <li class="step">Uw contact gegevens</li>
                                <li class="step active">Controle melding</li>
                                <li class="step">Ondertekenen</li>
                            </ng-container>
                            <ng-container *ngIf="form.controls.report_type_id.value === 2">
                                <li class="step">Verwachte overlast</li>
                                <li class="step">Locatie van de voorgenomen activiteiten</li>
                                <li class="step">Uw bedrijfsgegevens</li>
                                <li class="step">Contactpersoon</li>
                                <li class="step active">Controle melding</li>
                                <li class="step">Ondertekenen</li>
                            </ng-container>
                        </ul>
                    </div>
                </div>
            </form>
        </fury-container>
    </fury-page-layout-content>
</fury-page-layout>
